import { isAPIError } from '@sales-center/common'
import { fetchOverdueActivitiesCount } from '@user/features/Activity/store'
import { selectCurrentUser } from '@user/store/authorization'
import { useAppDispatch } from '@user/store/hooks'
import { useSelector } from 'react-redux'
import { updateActivity } from '../../../EditActivityPopover/EditActivityForm/effects/updateActivity.effect'
import { Props } from '../EditStatusActivityForm'
import { NormalizedActivity } from '../typings'

export function useHandlers(props: Props) {
  const { onClose, onSave } = props
  const appDispatch = useAppDispatch()
  const { userId } = useSelector(selectCurrentUser)
  async function onSubmit(model) {
    onClose()
    const result = await updateActivity(model)
    await appDispatch(fetchOverdueActivitiesCount(userId))
    if (!isAPIError(result) && onSave) {
      const normalizedActivity = normalizeActivity(model)
      onSave(normalizedActivity)
    }
  }

  function normalizeActivity(model): NormalizedActivity {
    const activity: NormalizedActivity = { ...model }
    return activity
  }

  return { onSubmit }
}
